import moment from 'moment'

export const ncrCorrective = {
  id: '',
  ncrNo: '',
  ncrId: '',
  actionNo: '',
  rootCauseType: '',
  rootCauseRemark: '',
  actionType: '',
  actionRemark: '',
  picId: '',
  picName: '',
  picEmail: '',
  workDescription: '',
  isRevision: 0,
  evidence: '',
  item: '',
  remark: '',
  targetDate: moment().format('YYYY-MM-DD'),
}

export const ncrCorrectiveDetail = {
  id: '',
  correctiveInternalId: '',
  ncrNo: '',
  type: '',
  isRevision: '',
  workDescription: '',
  evidence: '',
  completionDate: moment().format('YYYY-MM-DD'),
  createdBy: '',
  updatedBy: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}

export const ncrCorrectiveInternal = {
  id: '',
  correctiveActionNumber: '',
  ncrId: '',
  rootCause: '',
  corrective: '',
  correctivePicId: '',
  correctiveTargetDate: moment().format('YYYY-MM-DD'),
  preventive: '',
  preventivePicId: '',
  preventiveTargetDate: moment().format('YYYY-MM-DD'),
}